// Flexible Secure Context Manager with Graceful Fallback
export class FlexibleSecureContextManager {
  static checkVoiceAvailability(): {
    hasSecureContext: boolean;
    hasMediaDevices: boolean;
    hasSpeechRecognition: boolean;
    hasSpeechSynthesis: boolean;
    canUseVoice: boolean;
    recommendations: string[];
  } {
    const hasSecureContext = window.isSecureContext || 
                           location.protocol === 'https:' || 
                           location.hostname === 'localhost' ||
                           location.hostname === '127.0.0.1';
    
    const hasMediaDevices = !!navigator.mediaDevices?.getUserMedia;
    const hasSpeechRecognition = !!(window.SpeechRecognition || window.webkitSpeechRecognition);
    const hasSpeechSynthesis = !!window.speechSynthesis;
    
    const canUseVoice = hasSecureContext && hasMediaDevices && hasSpeechRecognition;
    
    const recommendations: string[] = [];
    
    if (!hasSecureContext) {
      recommendations.push('Access via HTTPS or localhost for voice features');
      recommendations.push(`Try: https://localhost:3000 or https://${location.hostname}:${location.port}`);
    }
    
    if (!hasMediaDevices) {
      recommendations.push('Browser does not support microphone access');
    }
    
    if (!hasSpeechRecognition) {
      recommendations.push('Browser does not support speech recognition');
    }

    return {
      hasSecureContext,
      hasMediaDevices,
      hasSpeechRecognition,
      hasSpeechSynthesis,
      canUseVoice,
      recommendations
    };
  }

  static getAccessInstructions(): string {
    const currentHost = location.hostname;
    const currentPort = location.port;
    
    return `
      🔒 For voice features, access via:
      • https://${currentHost}${currentPort ? ':' + currentPort : ''}
      • OR https://localhost:3000 for development
      
      💬 Text conversation available now!
    `;
  }

  static getCurrentContextInfo(): string {
    const capabilities = this.checkVoiceAvailability();
    
    return `
      Current Context: ${location.protocol}//${location.host}
      Secure Context: ${capabilities.hasSecureContext ? '✅ Yes' : '❌ No'}
      Voice Available: ${capabilities.canUseVoice ? '✅ Yes' : '❌ No'}
      Text-to-Speech: ${capabilities.hasSpeechSynthesis ? '✅ Yes' : '❌ No'}
    `;
  }
} 